import {fetchBody, URL_CONTRACTOR_GET_SKILL, URL_CONTRACTOR_GET_RESUME_OTHERDATA, URL_CONTRACTOR_ADD_RESUME_OTHERDATA, URL_CONTRACTOR_ADD_RESUME, URL_CONTRACTOR_UPDATE_RESUME, URL_CONTRACTOR_GET_RESUME_LIST, URL_CONTRACTOR_GET_RESUME_DETAIL, URL_CONTRACTOR_CHECK_RESUME, URL_EMPLOYEE_ADD_RESUME_OTHERDATA, URL_EMPLOYEE_GET_RESUME_OTHERDATA} from "../config"
import { toLogout, cleanFetch } from "./apiTools";
import { getToken } from "../component/Login/Auth";

//外部員工

export function api_getResumeList ({mReqResumeList, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqResumeList, token}), 
      url: URL_CONTRACTOR_GET_RESUME_LIST, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_contractorResumeCheck ({mReqResumeAdd, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqResumeAdd, token}), 
      url: URL_CONTRACTOR_CHECK_RESUME, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}
export function api_contractorResumeAdd ({mReqResumeAdd, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqResumeAdd, token}), 
      url: URL_CONTRACTOR_ADD_RESUME, 
      success:(jsonDate)=>{
        success(jsonDate)
        return jsonDate
      },
      failure:(error)=>{
        failure(error)
        return error
      }
    })
  }
}

export function api_contractorResumeDetail ({mReqResumeDetail, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqResumeDetail, token}), 
      url: URL_CONTRACTOR_GET_RESUME_DETAIL, 
      success:(jsonDate)=>{
        success(jsonDate)
        return jsonDate
      },
      failure:(error)=>{
        failure(error)
        return error
      }
    })
  }
}

export function api_contractorResumeUpdate({mReqResumeEdit}){
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqResumeEdit, token}), 
      url: URL_CONTRACTOR_UPDATE_RESUME, 
      success:(jsonDate)=>{
        return jsonDate
      },
      failure:(error)=>{
        return error
      }
    })
  }
}

export function api_getSkill ({success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({token}), 
      url: URL_CONTRACTOR_GET_SKILL, 
      success:(jsonDate)=>{
        success(jsonDate)
        return jsonDate
      },
      failure:(error)=>{
        failure(error)
        return error
      }
    })
  }
}

export function api_addResumeOtherData ({mRespResumeOtherData, isEmployee, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mRespResumeOtherData, token}), 
      url: isEmployee?URL_EMPLOYEE_ADD_RESUME_OTHERDATA:URL_CONTRACTOR_ADD_RESUME_OTHERDATA, 
      success:success,
      failure:failure
    })
  }
}

export function api_getResumeOtherData ({mReqResumeOtherData, isEmployee, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqResumeOtherData, token}), 
      url: isEmployee?URL_EMPLOYEE_GET_RESUME_OTHERDATA:URL_CONTRACTOR_GET_RESUME_OTHERDATA, 
      success: async (jsonDate)=>{
        success(jsonDate)
        return jsonDate
      },
      failure: async (error)=>{
        failure(error)
        return error
      }
    })
  }
}